import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import './CartDrawer.css';

const API_BASE = window.location.hostname === 'localhost' ? 'http://localhost:4000' : 'https://neoclic.kern-studio.com';

const formatearConPuntos = (valor) => {
    if (valor === null || valor === undefined || Number.isNaN(Number(valor))) {
        return '0';
    }
    return valor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

const CartDrawer = () => {
    const { cart, isCartOpen, setIsCartOpen, removeFromCart, updateQuantity, clearCart } = useContext(CartContext);
    const { user } = useAuth(); 
    const navigate = useNavigate();

    const subtotal = cart.reduce((total, item) => total + (item.precio * item.cantidad), 0);

    // 🚨 NUEVA FUNCIÓN: REDIRIGE A LA PÁGINA DE CHECKOUT 🚨
    const handleGoToCheckout = () => {
        setIsCartOpen(false); // Cerramos el carrito lateral para que no estorbe

        if (!user) {
            alert("Para garantizar la seguridad de tu pedido, por favor inicia sesión o regístrate.");
            navigate('/login');
            return; 
        }

        // Si ya está logueado, lo mandamos directo a la nueva pasarela de NeoClic
        navigate('/checkout');
    };

    return (
        <>
            <div className={`cart-overlay ${isCartOpen ? 'open' : ''}`} onClick={() => setIsCartOpen(false)}></div>

            <div className={`cart-drawer ${isCartOpen ? 'open' : ''}`}>
                <div className="cart-header">
                    <h2>Tu Carrito</h2>
                    <button className="close-btn" onClick={() => setIsCartOpen(false)}>✖</button>
                </div>

                <div className="cart-body">
                    {cart.length === 0 ? (
                        <div className="empty-cart-message">
                            <p>Tu carrito está vacío.</p>
                            <span className="empty-icon">🛒</span>
                        </div>
                    ) : (
                        cart.map((item) => (
                            <div className="cart-item" key={item.id_carrito}>
                                <img src={`${API_BASE}${item.imagen}`} alt={item.titulo} className="cart-item-img" />
                                
                                <div className="cart-item-info">
                                    <h4 className="cart-item-title">{item.titulo}</h4>
                                    <span className="cart-item-variant">{item.variante}</span>
                                    <span className="cart-item-price">${formatearConPuntos(item.precio)}</span>
                                    
                                    <div className="cart-item-controls">
                                        <div className="qty-controls">
                                            <button onClick={() => updateQuantity(item.id_carrito, -1)}>-</button>
                                            <span>{item.cantidad}</span>
                                            <button onClick={() => updateQuantity(item.id_carrito, 1)}>+</button>
                                        </div>
                                        <button className="delete-btn" onClick={() => removeFromCart(item.id_carrito)} title="Eliminar producto">
                                            🗑️
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {cart.length > 0 && (
                    <div className="cart-footer">
                        <div className="cart-subtotal">
                            <span>Subtotal:</span>
                            <h3>${formatearConPuntos(subtotal)}</h3>
                        </div>
                        
                        <div className="checkout-methods" style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '15px' }}>
                            
                            {/* 🚨 BOTÓN PRINCIPAL ACTUALIZADO PARA IR AL CHECKOUT 🚨 */}
                            <button 
                                onClick={handleGoToCheckout}
                                style={{
                                    width: '100%',
                                    padding: '14px',
                                    backgroundColor: '#3b82f6', 
                                    color: '#ffffff',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '10px',
                                    fontWeight: 'bold',
                                    fontSize: '15px',
                                    transition: 'background-color 0.2s',
                                    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#3b82f6'}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z"/>
                                    <path d="m9 12 2 2 4-4"/>
                                </svg>
                                Proceder al Pago Seguro
                            </button>

                            <button 
                                className="btn-cancel" 
                                onClick={clearCart} 
                                style={{ width: '100%', marginTop: '5px', backgroundColor: 'transparent', border: '1px solid #334155', color: '#94a3b8', padding: '10px', borderRadius: '6px', cursor: 'pointer' }}
                            >
                                Vaciar Carrito
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default CartDrawer;